export const PROJECTS_LOAD = "projects/LOAD";
export const PROJECTS_STATE = "projects/SET";
